import axios from "axios";
import { API_GET_CITY_DATA, API_INSERT_CITY_DATA, API_TOGGLE_CITY_DATA, API_UPDATE_CITY_DATA } from ".";

export const getCityList = async (func, config) => {
    return axios.get(API_GET_CITY_DATA, config).then(res => func(res.data.data));
}

export const insertCityData = async (data, config) => {
    return axios.post(API_INSERT_CITY_DATA, data, config).then((res) => res.data);
};

export const updateCityData = async (data, config) => {
    return axios.put(API_UPDATE_CITY_DATA, data, config).then((res) => res.data);
};

export const toggleCityData = async (data, config, cb) => {
    return axios.put(API_TOGGLE_CITY_DATA, data, config).then((res) => {
        if (res.data.status === "success") {
            cb();
        };
    });
};